// extracted by mini-css-extract-plugin
export default {"container":"Ao-z","blurb":"Bo-z","links":"Co-z"};